import { withStyles } from "@material-ui/core";
import React from "react";
const styles = (theme) => ({
  header: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.dispatchPanelHeaderColor,
    lineHeight: "16px",
    fontWeight: 500,
    paddingTop: 8,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
  },
});

const Header = ({ classes, label }) => (
  <div className={classes.header}>{label}</div>
);

export default withStyles(styles)(Header);
